<div class="px-3" [attr.data-testid]="'client-profile-details-container'">
    <!-- Balance -->
    <div class="flex align-items-center justify-content-between text-sm border-bottom-1 border-300 py-2 md:mt-2 px-2" [attr.data-testid]="'balance-section'">
        <div [attr.data-testid]="'outstanding-balance'">
            <label class="font-medium text-700 text-xs mb-1 block uppercase" [attr.aria-label]="'outstanding-balance-label'">{{'CLIENT_PROFILE.OWES' | translate}}</label>
            <strong *ngIf="!showSkeleton" class="p-error font-bold" [attr.aria-label]="'outstanding-balance-amount'">{{client.total_outstanding_in_minor_currency | currencyformat}}</strong>
            <p-skeleton *ngIf="showSkeleton" height="1rem" [attr.data-testid]="'outstanding-balance-skeleton'"></p-skeleton>
        </div>
        <div class="mx-2" [attr.data-testid]="'credit-balance'">
            <label class="font-medium text-700 text-xs mb-1 block uppercase" [attr.aria-label]="'credit-balance-label'">{{'CLIENT_PROFILE.CREDIT_BALANCE' | translate}}</label>
            <strong (click)="client.credit_balance > 0 ? showCreditBalancePopup() : ''" *ngIf="!showSkeleton" class="text-green-500 font-bold flex align-items-center" [ngClass]="{'cursor-pointer': client.credit_balance > 0}" [attr.aria-label]="'credit-balance-amount'">
                {{client.credit_balance | currencyformat}}
                <i class="fa fa-arrow-up-right-from-square ml-2 text-sm text-600" [attr.data-testid]="'credit-balance-icon'"></i>
            </strong>
            <p-skeleton *ngIf="showSkeleton" height="1rem" [attr.data-testid]="'credit-balance-skeleton'"></p-skeleton>
        </div>
        <div [attr.data-testid]="'lifetime-value'">
            <label class="font-medium text-700 text-xs mb-1 block uppercase" [attr.aria-label]="'lifetime-value-label'">{{'CLIENT_PROFILE.LIFETIME_VALUE' | translate}}</label>
            <strong *ngIf="!showSkeleton" class="text-primary font-bold flex align-items-center" [attr.aria-label]="'lifetime-value-amount'">
                {{client.lifetime_value | currencyformat}}
                <img
                    class="ml-3"
                    *ngIf="crownType(client.client_since).coin !== 'default' && !isProspect(client.client_status) && !isDefaultDate(client.client_since)"
                    [src]="'/assets/img/icons/'+crownType(client.client_since).coin+'.svg'"
                    alt="Icon"
                    [attr.data-testid]="'lifetime-value-icon'"
                />
            </strong>
            <p-skeleton *ngIf="showSkeleton" height="1rem" [attr.data-testid]="'lifetime-value-skeleton'"></p-skeleton>
        </div>
    </div>
    <!-- Balance -->

<form [formGroup]="updateClientFormGroup" [attr.data-testid]="'client-profile-form'">
    <!-- Card -->
    <div class="mt-2 text-xs text-600" [attr.data-testid]="'client-info-card'">
        <div class="flex align-items-center justify-content-between mb-2" [attr.data-testid]="'home-club-section'">
            <div class="text-xs text-600" *ngIf="!showSkeleton && !isProspect(client.client_status)" [attr.aria-label]="'home-club-label'">{{'CLIENT_PROFILE.HOME_CLUB' | translate}}</div>
            <div class="text-xs text-600" *ngIf="!showSkeleton && isProspect(client.client_status)" [attr.aria-label]="'prospect-club-label'">{{'CLIENT_PROFILE.PROSPECT_CLUB' | translate}}</div>
            <div *ngIf="!showSkeleton" class="text-900 font-bold hyperlink underline cursor-pointer" [ngClass]="isCurrentTenantClient ? 'text-900' : 'p-error'" (click)="toggleClientHistory()" [attr.data-testid]="'club-name'">
                {{ActiveTenant(client)?.name_primary_language || '---'}}
            </div>
            
            <p-skeleton *ngIf="showSkeleton" width="5rem" height="1rem" [attr.data-testid]="'club-name-skeleton'"></p-skeleton>
        </div>
        <div class="flex align-items-center justify-content-between mb-2" [attr.data-testid]="'member-since-section'">
            <div [attr.aria-label]="'member-since-label'">{{'CLIENT_PROFILE.MEMBER_SINCE' | translate}}</div>
            <div *ngIf="!showSkeleton" class="text-900 font-bold flex align-items-center" [attr.data-testid]="'member-since-date'">
                {{ isDefaultDate(client.client_since) ? '---' : client.client_since | datetimeformat: 'mediumDate'}}
                <span class="text-600 font-normal text-xs ml-2" *ngIf="!isDefaultDate(client.client_since)" [attr.data-testid]="'member-since-duration'">({{memberSince(client.client_since).exact}})</span>
            </div>
            <p-skeleton *ngIf="showSkeleton" width="5rem" height="1rem" [attr.data-testid]="'member-since-skeleton'"></p-skeleton>
        </div>
        <div class="flex align-items-center justify-content-between mb-2" [attr.data-testid]="'sales-rep-section'">
            <div [attr.aria-label]="'sales-rep-label'">{{'CLIENT_PROFILE.SALES_REP' | translate}}</div>
            <div *ngIf="!showSkeleton">
                <div *ngIf="!changeSalesRep" (click)="toggleChangeSaleRepDialog()" [attr.data-testid]="'sales-rep-name'" class="font-bold text-900 cursor-pointer">{{ (getSalesRep(client.client_representative_id) | async).name}}</div>
            </div>
            <p-skeleton *ngIf="showSkeleton" width="5rem" height="1rem" [attr.data-testid]="'sales-rep-skeleton'"></p-skeleton>
        </div>
        <div class="flex align-items-center justify-content-between mb-2" [attr.data-testid]="'last-visited-section'">
            <div [attr.aria-label]="'last-visited-label'">{{'CLIENT_PROFILE.LAST_VISITED_DATE' | translate}}</div>
            <div *ngIf="!showSkeleton && client.last_visited_center > 0; else dash" class="text-900 font-bold" [attr.data-testid]="'last-visited-date'">{{client.last_visited_date_time | DayAgo }}</div>
            <ng-template #dash>
                <p [attr.data-testid]="'last-visited-dash'">---</p>
            </ng-template>
            <p-skeleton *ngIf="showSkeleton" width="5rem" height="1rem" styleClass="mb-2" [attr.data-testid]="'last-visited-skeleton'"></p-skeleton>
        </div>
        <div class="flex align-items-center justify-content-between mb-2" [attr.data-testid]="'channel-section'">
            <div [attr.aria-label]="'channel-label'">{{'CLIENT_PROFILE.CHANNEL' | translate}}</div>
            <div *ngIf="!showSkeleton">
                <div *ngIf="!changeChannel" (click)="changeChannel=true" class="font-bold text-900 cursor-pointer" [attr.data-testid]="'channel-value'">{{client.channel}}</div>
                <p-select *ngIf="changeChannel" formControlName="channel" dropdownIcon="fa fa-angle-down text-sm" styleClass="text-xs w-10rem" [options]="channelCollection" optionLabel="channel" (onChange)="onChannelUpdate()" [attr.aria-label]="'channel-dropdown'">
                    <ng-template pTemplate="selectedItem">
                        <div *ngIf="updateClientFormGroup.get('channel')?.value" class="text-xs font-bold text-900" [attr.data-testid]="'selected-channel'">{{updateClientFormGroup.get('channel')?.value.channel}}</div>
                    </ng-template>
                    <ng-template let-channel pTemplate="item">
                        <div class="text-xs" (click)="changeChannel = false" [attr.data-testid]="'channel-option'">{{channel.channel}}</div>
                    </ng-template>
                </p-select>
            </div>
            <p-skeleton *ngIf="showSkeleton" width="5rem" height="1rem" [attr.data-testid]="'channel-skeleton'"></p-skeleton>
        </div>
        <div class="flex align-items-center justify-content-between mb-2" [attr.data-testid]="'source-section'">
            <div [attr.aria-label]="'source-label'">{{'CLIENT_PROFILE.SOURCE' | translate}}</div>
            <div *ngIf="!showSkeleton">
                <div *ngIf="!changeSource" (click)="changeSource=true" class="font-bold text-900 cursor-pointer" [attr.data-testid]="'source-value'">{{client.source}}</div>
                <p-select *ngIf="changeSource" formControlName="source" dropdownIcon="fa fa-angle-down text-sm" styleClass="text-xs w-10rem" [options]="Source" (onChange)="onSourceUpdate()" [attr.aria-label]="'source-dropdown'">
                    <ng-template pTemplate="selectedItem">
                        <div *ngIf="updateClientFormGroup.get('source')?.value" class="text-xs font-bold text-900" [attr.data-testid]="'selected-source'">{{updateClientFormGroup.get('source')?.value}}</div>
                    </ng-template>
                    <ng-template let-source pTemplate="item">
                        <div class="text-xs" (click)="changeSource=false" [attr.data-testid]="'source-option'">{{source}}</div>
                    </ng-template>
                </p-select>
            </div>
            <p-skeleton *ngIf="showSkeleton" width="5rem" height="1rem" [attr.data-testid]="'source-skeleton'"></p-skeleton>
        </div>
    </div>
    <!-- Card -->

    <!-- Client Details -->
    <div [attr.data-testid]="'client-details-section'">
        <div class="text-xs font-bold flex justify-content-between align-items-center mt-3">
            <div class="flex align-items-center text-900" [attr.aria-label]="'client-details-header'">
                <span>{{'CLIENT_PROFILE.CLIENT_DETAILS' | translate }}</span>
            </div>
        </div>
        <div class="py-1">
            <ul class="list-none m-0 p-0 text-xs text-600">
                <li class="flex align-items-center justify-content-between mb-2" [attr.data-testid]="'mobile-section'">
                    <div [attr.aria-label]="'mobile-label'">{{'CLIENT_PROFILE.MOBILE' | translate}}</div>
                    <div *ngIf="!showSkeleton">
                        <div *ngIf="!changeMobile" (click)="isCurrentTenantClient ? changeMobile=true : null" class="text-900 text-xs inline-flex align-items-center cursor-pointer" [attr.data-testid]="'mobile-number'">
                            {{client.mobile_country_code}}{{client.mobile_number}} 
                        </div>

                        <div *ngIf="changeMobile" class="p-inputgroup" [attr.data-testid]="'mobile-input-group'">
                            <ngx-intl-tel-input
                                [cssClass]="updateClientFormGroup.get('mobile_number')?.invalid ? 'p-invalid w-7rem':'w-7rem'"
                                [enableAutoCountrySelect]="false"
                                [enablePlaceholder]="true"
                                [searchCountryFlag]="false"
                                [selectFirstCountry]="false"
                                [selectedCountryISO]="clientMobileNoCountry ? clientMobileNoCountry : this.tenantCountry"
                                [onlyCountries]="onlyCountries"
                                [maxLength]="15"
                                [phoneValidation]="true"
                                [separateDialCode]="true"
                                formControlName="mobile_number"
                                [attr.aria-label]="'mobile-input'"
                            >
                            </ngx-intl-tel-input>
                            <button (click)="onMobileNumberUpdate();" icon="fa fa-check" pButton class="text-sm" [attr.aria-label]="'update-mobile-button'"></button>
                        </div>
                    </div>

                    <p-skeleton *ngIf="showSkeleton" width="10rem" height="1rem" styleClass="mb-2" [attr.data-testid]="'mobile-skeleton'"></p-skeleton>
                </li>
                <li class="flex align-items-center justify-content-between mb-2" [attr.data-testid]="'email-section'">
                    <div [attr.aria-label]="'email-label'">{{'CLIENT_PROFILE.EMAIL' | translate}}</div>
                    <div *ngIf="!showSkeleton">
                        <div *ngIf="!changeEmail" (click)="isCurrentTenantClient ? changeEmail=true : null" class="text-900 text-xs inline-flex align-items-center cursor-pointer" [attr.data-testid]="'email-value'">
                            {{client.email_id}}
                        </div>
                        <div *ngIf="changeEmail" class="p-inputgroup" [attr.data-testid]="'email-input-group'">
                            <input type="email" class="text-xs w-12rem" pInputText formControlName="email_id" placeholder="Enter Email" (keyup.enter)="onEmailUpdate()" (blur)="onEmailUpdate()" [attr.aria-label]="'email-input'" />
                            <button (click)="changeEmail=false" icon="fa fa-check" pButton class="text-sm" [attr.aria-label]="'update-email-button'"></button>
                        </div>
                    </div>
                    <p-skeleton *ngIf="showSkeleton" width="10rem" height="1rem" [attr.data-testid]="'email-skeleton'"></p-skeleton>
                </li>
                <li class="flex flex-wrap align-items-center justify-content-between mb-2" [attr.data-testid]="'birthday-section'">
                    <div class="w-6" [attr.aria-label]="'birthday-label'">{{'CLIENT_PROFILE.BIRTHDAY' | translate}}</div>
                    <div *ngIf="!showSkeleton">
                        <div *ngIf="!changeDOB" (click)="isCurrentTenantClient ? changeDOB=true : null" class="text-900 text-xs inline-flex align-items-center cursor-pointer" [attr.data-testid]="'birthday-value'">{{ isDefaultDate(client.date_of_birth) ? '---' : client.date_of_birth | datetimeformat: 'mediumDate'}}</div>
                        <div class="mt-2">
                        <p-datepicker
                            *ngIf="changeDOB"
                            formControlName="date_of_birth"
                            [showIcon]="true"
                            icon="fa fa-calendar font-light"
                            dateFormat="M dd,yy"
                            [yearNavigator]="true"
                            yearRange="2023:2030"
                            placeholder="Select Date"
                            inputStyleClass="text-sm w-17rem"
                            styleClass="w-full text-sm"
                            (onSelect)="onDOBUpdate()"
                            [attr.aria-label]="'birthday-calendar'"
                        ></p-datepicker>
                    </div>
                    </div>
                    <p-skeleton *ngIf="showSkeleton" width="5rem" height="1rem" [attr.data-testid]="'birthday-skeleton'"></p-skeleton>
                </li>
                <li class="flex align-items-center justify-content-between mb-2" *ngIf="client && client.organisation" [attr.data-testid]="'organization-section'">
                    <div [attr.aria-label]="'organization-label'">{{'CLIENT_PROFILE.ORGANIZATION' | translate}}</div>
                    <div *ngIf="!showSkeleton" class="text-900" [attr.data-testid]="'organization-value'">{{client.organisation.name_primary_language || '-'}}</div>
                    <p-skeleton *ngIf="showSkeleton" width="10rem" height="1rem" [attr.data-testid]="'organization-skeleton'"></p-skeleton>
                </li>
                <li class="flex align-items-center justify-content-between mb-2" [attr.data-testid]="'gender-section'">
                    <div [attr.aria-label]="'gender-label'">{{'CLIENT_PROFILE.GENDER' | translate}}</div>
                    <div *ngIf="!showSkeleton">
                        <div *ngIf="!changeGender" (click)="isCurrentTenantClient ? changeGender=true : null" class="text-900 cursor-pointer" [attr.data-testid]="'gender-value'">{{client.gender}}</div>
                        <p-select *ngIf="changeGender" formControlName="gender" dropdownIcon="fa fa-angle-down text-sm" styleClass="text-xs w-10rem" [options]="EnumGender" optionLabel="value" (onChange)="onGenderUpdate()" [attr.aria-label]="'gender-dropdown'">
                            <ng-template pTemplate="selectedItem">
                                <div *ngIf="updateClientFormGroup.get('gender')?.value" class="text-xs text-900" [attr.data-testid]="'selected-gender'">{{updateClientFormGroup.get('gender')?.value.value}}</div>
                            </ng-template>
                            <ng-template let-gender pTemplate="item">
                                <div class="text-xs break-word text-left" (click)="changeGender=false" [attr.data-testid]="'gender-option'">{{gender.value}}</div>
                            </ng-template>
                        </p-select>
                    </div>
                    <p-skeleton *ngIf="showSkeleton" width="10rem" height="1rem" styleClass="mb-2" [attr.data-testid]="'gender-skeleton'"></p-skeleton>
                </li>
                <li class="flex justify-content-between mb-2" [attr.data-testid]="'emergency-contact-section'">
                    <div [attr.aria-label]="'emergency-contact-label'">{{'CLIENT_PROFILE.EMERGENCY_CONTACT' | translate}}</div>
                    <div *ngIf="!showSkeleton">
                        <div *ngIf="!changeEmergencyContact" (click)="isCurrentTenantClient ? changeEmergencyContact=true : null" class="text-900 text-xs text-right cursor-pointer" [attr.data-testid]="'emergency-contact-value'">
                            {{client.emergency_contact_person || '---'}} <span class="block">{{client.emergency_contact_number || '---'}}</span>
                        </div>
                        <div *ngIf="changeEmergencyContact" class="p-inputgroup" [attr.data-testid]="'emergency-contact-input-group'">
                            <input type="text" class="text-xs w-auto" pInputText formControlName="emergency_contact_person" placeholder="Enter Emergency Contact Name" [attr.aria-label]="'emergency-contact-name-input'" />
                            <ngx-intl-tel-input
                                [cssClass]="updateClientFormGroup.get('emergency_contact_number')?.invalid?'p-invalid':''"
                                [enableAutoCountrySelect]="false"
                                [enablePlaceholder]="true"
                                [searchCountryFlag]="false"
                                [selectFirstCountry]="false"
                                [selectedCountryISO]="tenantCountry"
                                [onlyCountries]="onlyCountries"
                                [maxLength]="15"
                                [phoneValidation]="true"
                                [separateDialCode]="true"
                                [numberFormat]="PhoneNumberFormat.National"
                                formControlName="emergency_contact_number"
                                [attr.aria-label]="'emergency-contact-number-input'"
                            >
                            </ngx-intl-tel-input>
                            <button (click)="onEmergencyContactUpdate()" icon="fa fa-check" pButton class="text-sm" [attr.aria-label]="'update-emergency-contact-button'"></button>
                        </div>
                    </div>
                    <p-skeleton *ngIf="showSkeleton" width="10rem" height="1rem" styleClass="mb-2" [attr.data-testid]="'emergency-contact-skeleton'"></p-skeleton>
                </li>
                <li class="mb-2" [attr.data-testid]="'address-section'">
                    <div class="flex justify-content-between align-items-start mb-1">
                        <div class="text-600 text-xs" [attr.aria-label]="'address-label'">{{'CLIENT_PROFILE.ADDRESS' | translate}}</div>
                    </div>
                    <div *ngIf="!showSkeleton">
                        <div *ngIf="!changeAddress" 
                             (click)="isCurrentTenantClient ? changeAddress=true : null" 
                             class="font-bold text-900 text-xs cursor-pointer line-height-3 text-right break-word" 
                             [attr.data-testid]="'address-value'">
                             {{client.address || '---'}}
                        </div>
                        <div *ngIf="changeAddress" class="p-inputgroup mt-1" [attr.data-testid]="'address-input-group'">
                            <textarea 
                                class="text-xs w-full border-round" 
                                pInputTextarea 
                                formControlName="address" 
                                placeholder="Enter Address" 
                                rows="3"
                                (keyup.enter)="onAddressUpdate()" 
                                (blur)="onAddressUpdate()" 
                                [attr.aria-label]="'address-input'">
                            </textarea>
                            <button (click)="changeAddress=false" icon="fa fa-check" pButton class="text-sm mt-1" [attr.aria-label]="'update-address-button'"></button>
                        </div>
                    </div>
                    <div *ngIf="showSkeleton" class="mt-1">
                        <p-skeleton width="100%" height="3rem" [attr.data-testid]="'address-skeleton'"></p-skeleton>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <!-- Client Details -->

    <!-- Marketing Preferences -->
    <div class="border-top-1 border-bottom-1 border-300 pt-2 mb-2 text-900" formGroupName="marketing_preferences" [attr.data-testid]="'marketing-preferences-section'">
        <strong class="block font-bold text-xs mb-0" [attr.aria-label]="'marketing-preferences-header'">{{'CLIENT_INTERACTION.MARKETING' | translate}}</strong>
        <ul class="list-none p-0 m-0 text-xs">
            <li class="flex align-items-center justify-content-between mb-1" [attr.data-testid]="'email-preference-section'">
                <div class="flex align-items-center">
                    <i class="fa fa-envelope text-base mr-2" [attr.data-testid]="'email-preference-icon'"></i>
                    <span [attr.aria-label]="'email-preference-label'">{{'CLIENT_PROFILE.EMAIL' | translate}}</span>
                </div>
                <p-toggleSwitch 
                    *ngIf="!showSkeleton" 
                    formControlName="email"
                    (onChange)="onMarketingPreferenceChange()"
                    [attr.aria-label]="'email-preference-toggle'">
                </p-toggleSwitch>
                <p-skeleton *ngIf="showSkeleton" width="4rem" height="2rem" [attr.data-testid]="'email-preference-skeleton'"></p-skeleton>
            </li>
            <li class="flex align-items-center justify-content-between mb-1" [attr.data-testid]="'sms-preference-section'">
                <div class="flex align-items-center">
                    <i class="fa fa-comment-sms text-lg mr-2" [attr.data-testid]="'sms-preference-icon'"></i>
                    <span [attr.aria-label]="'sms-preference-label'">{{'CLIENT_PROFILE.SMS' | translate}}</span>
                </div>
                <p-toggleSwitch 
                    *ngIf="!showSkeleton" 
                    formControlName="sms"
                    (onChange)="onMarketingPreferenceChange()"
                    [attr.aria-label]="'sms-preference-toggle'">
                </p-toggleSwitch>
                <p-skeleton *ngIf="showSkeleton" width="4rem" height="2rem" [attr.data-testid]="'sms-preference-skeleton'"></p-skeleton>
            </li>
            <li class="flex align-items-center justify-content-between mb-1" [attr.data-testid]="'whatsapp-preference-section'">
                <div class="flex align-items-center">
                    <i class="fab fa-whatsapp text-lg mr-2" [attr.data-testid]="'whatsapp-preference-icon'"></i>
                    <span [attr.aria-label]="'whatsapp-preference-label'">{{'CLIENT_PROFILE.WHATS_APP' | translate}}</span>
                </div>
                <p-toggleSwitch 
                    *ngIf="!showSkeleton" 
                    formControlName="whatsapp"
                    (onChange)="onMarketingPreferenceChange()"
                    [attr.aria-label]="'whatsapp-preference-toggle'">
                </p-toggleSwitch>
                <p-skeleton *ngIf="showSkeleton" width="4rem" height="2rem" [attr.data-testid]="'whatsapp-preference-skeleton'"></p-skeleton>
            </li>
        </ul>
    </div>
    <!-- Marketing Preferences -->

    <div class="mb-2 text-xs text-500" [attr.data-testid]="'additional-info-section'">
        <div *ngIf="client && client.organisation" [attr.data-testid]="'organization-info'">{{'CLIENT_PROFILE.ORGANIZATION' | translate}}: {{client.organisation.name_primary_language}}</div>
        <div *ngIf="client && client.national_id" [attr.data-testid]="'national-id-info'">{{'CLIENT_PROFILE.NATIONAL_ID' | translate}}: {{client.national_id}}</div>
    </div>
 </form>
</div>


<client-credit-balance *ngIf="showCreditBalance" [visible]="showCreditBalance" [clientId]="client.id" (closePopup)="closeCreditPopup($event)" [attr.data-testid]="'credit-balance-dialog'"></client-credit-balance>

<change-sales-representative
    *ngIf="toggleChangeSaleRepDialog$ | async"
    [changeRepresentativeModal]="toggleChangeSaleRepDialog$ | async"
    [clientData$]="clientDetailsObj"
    (closeChangeRepresentativeDialog)="closeChangeSaleRepDialog($event)"
    [attr.data-testid]="'change-sales-rep-dialog'"
></change-sales-representative>

<client-history *ngIf="showClientHistory" [clientHistoryModal]="showClientHistory" [clientData$]="clientDetailsObj" (closeClientHistoryDialog)="closeClientHistoryDialog($event)" [attr.data-testid]="'client-history-dialog'"></client-history>
